import React from 'react';
import { Box, Paper } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

export const fadeUp = keyframes`
from { opacity: 0; transform: translateY(14px); }
to { opacity: 1; transform: translateY(0); }
`;

export const PageWrapper = styled(Box)(({ theme }) => ({
minHeight: '100vh',
background: 'linear-gradient(135deg, #f0f7ff 0%, #fafafa 55%, #f5f0ff 100%)',
padding: theme.spacing(3),
}));

export const Inner = styled(Box)({
maxWidth: 1100,
margin: '0 auto',
animation: `${fadeUp} .45s ease-out`,
});

export const HeaderCard = styled(Paper)(({ theme }) => ({
background: 'linear-gradient(120deg, #0f2942 0%, #117aa7 100%)',
borderRadius: 20,
padding: theme.spacing(2.5, 4),
marginBottom: theme.spacing(3),
display: 'flex',
alignItems: 'center',
justifyContent: 'space-between',
boxShadow: '0 8px 32px rgba(17,122,167,.28)',
gap: theme.spacing(2),
}));

export const SummaryCard = styled(Paper)(({ theme }) => ({
background: '#ffffff',
borderRadius: 18,
border: '1.5px solid rgba(17,122,167,.18)',
padding: theme.spacing(2.5, 3),
boxShadow: '0 4px 20px rgba(17,122,167,.07)',
marginBottom: theme.spacing(2.5),
}));

export const StrengthCard = styled(Paper)(({ theme }) => ({
background: 'linear-gradient(135deg, #f0fdf4, #dcfce7)',
borderRadius: 18,
border: '1.5px solid rgba(34,197,94,.25)',
padding: theme.spacing(2.5),
height: '100%',
boxSizing: 'border-box',
boxShadow: '0 4px 18px rgba(34,197,94,.07)',
}));

export const GapCard = styled(Paper)(({ theme }) => ({
background: 'linear-gradient(135deg, #fff1f2, #ffe4e6)',
borderRadius: 18,
border: '1.5px solid rgba(239,68,68,.22)',
padding: theme.spacing(2.5),
height: '100%',
boxSizing: 'border-box',
boxShadow: '0 4px 18px rgba(239,68,68,.07)',
}));

export const CoachingCard = styled(Paper)(({ theme }) => ({
background: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
borderRadius: 18,
border: '1.5px solid rgba(245,158,11,.28)',
padding: theme.spacing(2.5, 3),
marginTop: theme.spacing(2.5),
boxShadow: '0 4px 18px rgba(245,158,11,.08)',
}));

export const ItemRow = styled(Box)(({ theme }) => ({
display: 'flex',
gap: theme.spacing(1.5),
alignItems: 'flex-start',
padding: theme.spacing(1.25, 1.5),
borderRadius: 10,
background: 'rgba(255,255,255,.65)',
border: '1px solid rgba(255,255,255,.9)',
transition: 'box-shadow .2s',
'&:hover': { boxShadow: '0 2px 10px rgba(0,0,0,.06)' },
}));

export const TrainingItem = styled(Box)(({ theme }) => ({
display: 'flex',
gap: theme.spacing(1.5),
alignItems: 'flex-start',
padding: theme.spacing(1.25, 1.5),
borderRadius: 10,
background: 'rgba(255,255,255,.6)',
border: '1px solid rgba(255,255,255,.85)',
transition: 'box-shadow .2s',
'&:hover': { boxShadow: '0 2px 10px rgba(0,0,0,.05)' },
}));

export const AccentBar = ({ color }) => (
<Box sx={{ width: 4, height: 22, bgcolor: color, borderRadius: 4, flexShrink: 0 }} />
);
